export default __webpack_public_path__ + "static/media/6.8e358ac4.png";